import React from "react";
import { PageLayout } from "../components/page-layout";
import ContentList from "../components/content/content-list";

export const AllContentPage = () => (
  <PageLayout>
    <ContentList showAllContent={true} />
  </PageLayout>
);
